// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__4R3Sz","title":"styles_title__2-Otu"};